import React from 'react'

import { useGetSiteUrl } from '@application/Interfaces/Hooks/useGetSiteUrl'
import { ThemeModeType } from '@src/Application/Types/ComponentTypes'

import { Wrapper } from './Html.styled'
import { updateHtmlElement } from './utils'

type Props = {
    content: string
    mode?: ThemeModeType
}

export const Html = ({ content, mode }: Props): JSX.Element => {
    const siteUrl = useGetSiteUrl()

    return (
        <Wrapper
            $mode={mode}
            dangerouslySetInnerHTML={{
                __html: updateHtmlElement({ content, siteUrl }),
            }}
        />
    )
}
